export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6351.5d541319.jpg";